import gql from 'graphql-tag';

export default gql`
  fragment salesforceLeadCreateActivityFragment on SalesforceLeadCreateActivity {
    preleadContactFirstName
    preleadContactLastName
  }
`;
